import React from "react";
import rightArrow from "../../../../assets/images/homepage/setting/ManageUser/rightArrow.svg";
import rightArrowDark from "../../../../assets/images/homepage/setting/ManageUser/rightArrowDark.svg";
import useTheme from "hooks/observer";
import AdvancedSettings from "../Admin/AdvancedSettings";
import "./advancedSettingsPage.scss";

function AdvancedSettingsPage({ setManageUser }) {
  const theme = useTheme();

  return (
    <div className="AdvancedSettingsPage">
      <div className="manageUserHeader">
        <p onClick={() => setManageUser("")} style={{ cursor: "pointer" }}>
          Settings
        </p>
        <img
          src={theme === "light" ? rightArrow : rightArrowDark}
          alt="arrow"
        />
        <p className="user">Advanced Settings</p>
      </div>

      <AdvancedSettings />
    </div>
  );
}

export default AdvancedSettingsPage;
